var _path, _rect, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIphone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 61,
    viewBox: "0 0 33 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5915 0.25H6.10366C2.88532 0.25 0.25 2.88532 0.25 6.10366V54.3963C0.25 57.6147 2.88532 60.25 6.10366 60.25H26.5915C29.8098 60.25 32.4451 57.6147 32.4451 54.3963V6.10366C32.4451 2.88532 29.8098 0.25 26.5915 0.25ZM30.9817 54.3963C30.9817 56.8173 29.0124 58.7866 26.5915 58.7866H6.10366C3.68273 58.7866 1.71341 56.8173 1.71341 54.3963V6.10366C1.71341 3.68273 3.68273 1.71341 6.10366 1.71341H26.5915C29.0124 1.71341 30.9817 3.68273 30.9817 6.10366V54.3963Z",
    fill: "#1D1616",
    stroke: "#1D1616",
    strokeWidth: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.25,
    y: 3.25,
    width: 26,
    height: 54,
    rx: 3,
    fill: "#047DED",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0353 7.17703H12.7014C11.8868 7.17703 11.2266 6.51964 11.2266 5.71362C11.2266 4.9076 11.8868 4.2502 12.7014 4.2502H20.0353C21.9446 4.22162 21.9503 7.20564 20.0353 7.17703Z",
    fill: "#047DED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76296 54.25H22.9337C23.3367 54.25 23.6654 54.653 23.6654 54.9817C23.6654 55.3847 23.3367 55.7134 22.9337 55.7134H9.76296C9.35995 55.7134 9.03125 55.3104 9.03125 54.9817C9.03125 54.5787 9.35995 54.25 9.76296 54.25Z",
    fill: "#047DED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphone);
export default __webpack_public_path__ + "static/media/iphone.ab83b9cf6fa022c6b255d5b9f5ff1afb.svg";
export { ForwardRef as ReactComponent };